"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ripple = exports.Loader = exports.Body = exports.IconWrapper = exports.Right = exports.Left = exports.ButtonStyle = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _ChevronLeft = _interopRequireDefault(require("./assets/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("./assets/ChevronRight"));

var _Loader2 = _interopRequireDefault(require("../../Loader"));

var _typesProps = _interopRequireDefault(require("./typesProps"));

var _styles = require("../../../shared/styles");

var _selectors = require("../../../shared/styles/themes/selectors");

var _Ripple2 = _interopRequireDefault(require("../../Ripple"));

var _Div = _interopRequireDefault(require("../../Div"));

var _Flex = _interopRequireDefault(require("../../Flex"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject26() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  color: ", ";\n  ", "\n"]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n      text-align: ", ";\n    "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n      margin-", ": 0;\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  align-items: center;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      margin-", ": 10px;\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n      min-width: 20px;\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  ", "\n  ", "\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      margin: 0;\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin: auto;\n  margin-left: 10px;\n  ", "\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      margin: 0;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin: auto;\n  margin-right: 10px;\n  ", "\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n\t\theight: 21px;\n\t\twidth: 21px;\n\t"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n\t\theight: 18px;\n\t\twidth: 18px;\n\t"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  height: 17px;\n  width: 17px;\n  ", "\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      cursor: default;\n      background-color: ", ";\n      color: ", ";\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      border-radius: ", "px;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      text-transform: uppercase;\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n\t\tmin-height: ", "px;\n\t\tmax-height: ", "px;\n\t"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n\t\tmin-height: ", "px;\n\t\tmax-height: ", "px;\n\t"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n  line-height: 1.2em;\n  text-align: center;\n  text-decoration: none;\n  background-color: ", ";\n  color: ", ";\n  border: 0;\n  border-style: solid;\n  border-width: ", ";\n  border-color: ", ";\n  ", "\n  transition: all ease .5s;\n  padding: 0 10px;\n  min-height: ", "px;\n  max-height: ", "px;\n  -webkit-appearance: none !important;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    &:hover:enabled {\n      background-color: ", ";\n      color: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var buttonSizes = {
  s: {
    height: 40
  },
  m: {
    height: 55
  },
  l: {
    height: 70
  }
};

var buttonTypeCss = function buttonTypeCss(_ref) {
  var background = _ref.background,
      color = _ref.color,
      hoverBackground = _ref.hoverBackground,
      hoverColor = _ref.hoverColor,
      customCss = _ref.customCss,
      rest = _objectWithoutProperties(_ref, ["background", "color", "hoverBackground", "hoverColor", "customCss"]);

  return (0, _styledComponents.css)(_templateObject(), background, color, function (_ref2) {
    var hover = _ref2.hover;
    return hover && _styles.media.desktop(_templateObject2(), hoverBackground || color, hoverColor || background);
  }, rest, customCss);
};

var getTypeCss = function getTypeCss(props) {
  return buttonTypeCss((0, _typesProps["default"])(props));
};

var ButtonStyle = _styledComponents["default"].button(_templateObject3(), function (_ref3) {
  var widthAuto = _ref3.widthAuto;
  return !widthAuto && (0, _styledComponents.css)(_templateObject4());
}, function (props) {
  return (0, _selectors.getField)('button.backgroundColor', props);
}, function (props) {
  return (0, _selectors.getField)('button.color', props);
}, function (props) {
  return (0, _selectors.getField)('button.borderWidth', props);
}, function (props) {
  return (0, _selectors.getField)('button.borderColor', props);
}, (0, _styles.fontWeight)('extrabold'), function (_ref4) {
  var size = _ref4.size;
  return buttonSizes[size].height;
}, function (_ref5) {
  var size = _ref5.size;
  return buttonSizes[size].height;
}, _styles.media.tablet(_templateObject5(), function (_ref6) {
  var size = _ref6.size;
  return buttonSizes[size].height + 6;
}, function (_ref7) {
  var size = _ref7.size;
  return buttonSizes[size].height + 6;
}), _styles.media.desktop(_templateObject6(), function (_ref8) {
  var size = _ref8.size;
  return buttonSizes[size].height + 9;
}, function (_ref9) {
  var size = _ref9.size;
  return buttonSizes[size].height + 9;
}), function (_ref10) {
  var size = _ref10.fontSize;
  return (0, _styles.fontSize)(size);
}, (0, _styles.letterSpacing)(), (0, _styles.margin)('m', 'bottom'), function (_ref11) {
  var uppercase = _ref11.uppercase;
  return uppercase && (0, _styledComponents.css)(_templateObject7());
}, function (_ref12) {
  var rounded = _ref12.rounded;
  return rounded && (0, _styledComponents.css)(_templateObject8(), function (_ref13) {
    var size = _ref13.size;
    return buttonSizes[size].height;
  });
}, function (_ref14) {
  var disabled = _ref14.disabled,
      props = _objectWithoutProperties(_ref14, ["disabled"]);

  return disabled && (0, _styledComponents.css)(_templateObject9(), (0, _polished.transparentize)(0.85, (0, _selectors.getField)('button.backgroundColor', props)), (0, _polished.transparentize)(0.6, (0, _selectors.getField)('button.color', props)));
}, function (_ref15) {
  var locked = _ref15.locked,
      props = _objectWithoutProperties(_ref15, ["locked"]);

  return locked && (0, _styledComponents.css)(_templateObject10(), (0, _polished.transparentize)(0.85, (0, _selectors.getField)('button.backgroundColor', props)));
}, getTypeCss, _styles.addCssProp);

exports.ButtonStyle = ButtonStyle;
var defaultArrowStyle = (0, _styledComponents.css)(_templateObject11(), _styles.media.tablet(_templateObject12()), _styles.media.desktop(_templateObject13()));
var Left = (0, _styledComponents["default"])(_ChevronLeft["default"])(_templateObject14(), defaultArrowStyle, function (_ref16) {
  var align = _ref16.align;
  return align === 'justify' && (0, _styledComponents.css)(_templateObject15());
}, function (_ref17) {
  var arrowStyle = _ref17.arrowStyle;
  return arrowStyle;
});
exports.Left = Left;
var Right = (0, _styledComponents["default"])(_ChevronRight["default"])(_templateObject16(), defaultArrowStyle, function (_ref18) {
  var align = _ref18.align;
  return align === 'justify' && (0, _styledComponents.css)(_templateObject17());
}, function (_ref19) {
  var arrowStyle = _ref19.arrowStyle;
  return arrowStyle;
});
exports.Right = Right;
var IconWrapper = (0, _styledComponents["default"])(_Div["default"])(_templateObject18(), function (_ref20) {
  var iconMargin = _ref20.iconMargin;
  return iconMargin && (0, _styledComponents.css)(_templateObject19());
}, function (_ref21) {
  var position = _ref21.position,
      reverse = _ref21.reverse,
      iconMargin = _ref21.iconMargin;
  var marginPosition = position === 'left' ? 'right' : 'left';
  return iconMargin && (0, _styledComponents.css)(_templateObject20(), reverse ? position : marginPosition);
});
exports.IconWrapper = IconWrapper;
var Body = (0, _styledComponents["default"])(_Flex["default"])(_templateObject21(), function (_ref22) {
  var align = _ref22.align;
  return ['right', 'left'].includes(align) && (0, _styledComponents.css)(_templateObject22(), align);
}, function (_ref23) {
  var align = _ref23.align;
  return align === 'justify' && (0, _styledComponents.css)(_templateObject23());
}, function (_ref24) {
  var align = _ref24.align;
  return (0, _styledComponents.css)(_templateObject24(), align);
});
exports.Body = Body;
var Loader = (0, _styledComponents["default"])(_Loader2["default"])(_templateObject25(), function (props) {
  return (0, _selectors.getField)('button.color', props);
}, getTypeCss);
exports.Loader = Loader;
var Ripple = (0, _styledComponents["default"])(_Ripple2["default"]).attrs(function (props) {
  return {
    color: (0, _typesProps["default"])(props).color || (0, _selectors.getField)('button.ripple', props)
  };
})(_templateObject26());
exports.Ripple = Ripple;